import {Component} from '@angular/core';
import { NgForm }    from '@angular/forms';
import {UserService} from './user-service';

@Component({
    selector: 'dk-login',
    template: require('./login.html'),
    providers: [ UserService ]
})

export class LoginComponent {
    model:{
        username:string,
        password:string
    }

    constructor(private userService: UserService) {
        this.model = {
            username: null,
            password: null
        };
    }

    onSubmit(loginForm: NgForm) {
        for(let name in loginForm.controls) {
            loginForm.controls[name].markAsTouched();
        }

        if (loginForm.valid) {
            this.userService
                .login(this.model.username, this.model.password)
                .subscribe(
                    success => {
                        location.href = 'panel-klienta/dane-osobowe.html';
                    },
                    error =>  alert(error));
        }
    }
}
